const BASE_NAME = 'referral_module';

const SET_POST_TA_RATING_REFERRAL_MODAL = `${BASE_NAME
}/SET_POST_TA_RATING_REFERRAL_MODAL_STATE`;

const initialState = {
  modalState: false,
};

export function setPostTARatingReferralModalState(modalState) {
  return {
    type: SET_POST_TA_RATING_REFERRAL_MODAL,
    payload: modalState,
  };
}

export default function postTARatingReferralModalReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case SET_POST_TA_RATING_REFERRAL_MODAL: {
      return {
        ...state,
        modalState: action.payload,
      };
    }
    default:
      return state;
  }
}
